/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import * as b64$ from "../lib/base64.js";

export type PostImageNsfwFile = {
  fileName: string;
  content: Uint8Array | string;
};

export const PostImageNsfwFile$zodSchema: z.ZodType<PostImageNsfwFile> = z
  .object({
    content: z.string().describe("Base64-encoded binary content").transform(
      b64$.bytesFromBase64,
    ),
    fileName: z.string(),
  });

/**
 * 包含图片来源的表单数据。必须提供 'file' 或 'url' 两者之一。
 */
export type PostImageNsfwRequest = {
  file?: PostImageNsfwFile | Blob | undefined;
  url?: string | undefined;
};

export const PostImageNsfwRequest$zodSchema: z.ZodType<PostImageNsfwRequest> = z
  .object({
    file: z.lazy(() => PostImageNsfwFile$zodSchema).optional(),
    url: z.string().optional(),
  }).describe("包含图片来源的表单数据。必须提供 'file' 或 'url' 两者之一。");

/**
 * 服务器内部错误。在处理图片或进行 NSFW 检测时发生错误。
 */
export type PostImageNsfwInternalServerErrorResponseBody = {
  code?: string | undefined;
  message?: string | undefined;
};

export const PostImageNsfwInternalServerErrorResponseBody$zodSchema: z.ZodType<
  PostImageNsfwInternalServerErrorResponseBody
> = z.object({
  code: z.string().optional(),
  message: z.string().optional(),
}).describe("服务器内部错误。在处理图片或进行 NSFW 检测时发生错误。");

/**
 * 文件过大。上传的图片超过了 20MB 的限制。
 */
export type PostImageNsfwRequestEntityTooLargeResponseBody = {
  code?: string | undefined;
  message?: string | undefined;
};

export const PostImageNsfwRequestEntityTooLargeResponseBody$zodSchema:
  z.ZodType<PostImageNsfwRequestEntityTooLargeResponseBody> = z.object({
    code: z.string().optional(),
    message: z.string().optional(),
  }).describe("文件过大。上传的图片超过了 20MB 的限制。");

/**
 * 请求参数错误。可能是未提供图片、文件格式不支持或文件过大。
 */
export type PostImageNsfwBadRequestResponseBody = {
  code?: string | undefined;
  message?: string | undefined;
};

export const PostImageNsfwBadRequestResponseBody$zodSchema: z.ZodType<
  PostImageNsfwBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  message: z.string().optional(),
}).describe("请求参数错误。可能是未提供图片、文件格式不支持或文件过大。");

/**
 * 检测成功！返回图片的 NSFW 分析结果。
 */
export type PostImageNsfwResponseBody = {
  nsfw_score?: number | undefined;
  normal_score?: number | undefined;
  is_nsfw?: boolean | undefined;
  label?: string | undefined;
  suggestion?: string | undefined;
  risk_level?: string | undefined;
  confidence?: number | undefined;
  inference_time_ms?: number | undefined;
};

export const PostImageNsfwResponseBody$zodSchema: z.ZodType<
  PostImageNsfwResponseBody
> = z.object({
  confidence: z.number().optional(),
  inference_time_ms: z.number().optional(),
  is_nsfw: z.boolean().optional(),
  label: z.string().optional(),
  normal_score: z.number().optional(),
  nsfw_score: z.number().optional(),
  risk_level: z.string().optional(),
  suggestion: z.string().optional(),
}).describe("检测成功！返回图片的 NSFW 分析结果。");

export type PostImageNsfwResponse =
  | PostImageNsfwResponseBody
  | PostImageNsfwBadRequestResponseBody
  | PostImageNsfwRequestEntityTooLargeResponseBody
  | PostImageNsfwInternalServerErrorResponseBody;

export const PostImageNsfwResponse$zodSchema: z.ZodType<PostImageNsfwResponse> =
  z.union([
    z.lazy(() => PostImageNsfwResponseBody$zodSchema),
    z.lazy(() => PostImageNsfwBadRequestResponseBody$zodSchema),
    z.lazy(() => PostImageNsfwRequestEntityTooLargeResponseBody$zodSchema),
    z.lazy(() => PostImageNsfwInternalServerErrorResponseBody$zodSchema),
  ]);
